var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgExpand = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 3C3 2.58579 3.33578 2.25 3.75 2.25C4.16421 2.25 4.5 2.58579 4.5 3L4.5 21C4.5 21.4142 4.16421 21.75 3.74999 21.75C3.33578 21.75 2.99999 21.4142 2.99999 21L3 3ZM11.7803 6.96967C12.0732 7.26257 12.0732 7.73744 11.7803 8.03033L8.56065 11.25L21 11.25C21.4142 11.25 21.75 11.5858 21.75 12C21.75 12.4142 21.4142 12.75 21 12.75L8.56066 12.75L11.7803 15.9697C12.0732 16.2626 12.0732 16.7374 11.7803 17.0303C11.4874 17.3232 11.0126 17.3232 10.7197 17.0303L6.21966 12.5303C5.92677 12.2374 5.92677 11.7626 6.21966 11.4697L10.7197 6.96967C11.0126 6.67678 11.4874 6.67678 11.7803 6.96967Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgExpand);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/expand.faba579b10cedd8776240a43bb09229a.svg";